var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-preview-image has-text-grey-lighter"},[_c('b-icon',{attrs:{"icon":"camera","size":_vm.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }